import React, { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import MoveActivities from '../MoveActivities';

const modalMoveActivities = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth:'600px',
  width: '90%',
  margin: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
  border: '2px solid #0B57D0'
};

const MoveModal = ({ open, closeModal, handleMoveSelected }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [reason, setReason] = useState('');

  return (
    <Modal open={open} onClose={closeModal}>
      <Box sx={{ 
        ...modalMoveActivities,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '90vh',
        overflow: 'hidden',
      }}>
        {/* Header */}
        <Box sx={{ p: '0 0 15px 0', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff' }}>
          <Typography variant="h6">Move Activities</Typography>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 1 }}>
          <MoveActivities 
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            reason={reason}
            setReason={setReason}
          />
        </Box>

        {/* Footer */}
        <Box sx={{ p: 2, borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#fff', display: 'flex', justifyContent: 'space-between', gap: 2 }}>
          <Button onClick={closeModal} variant="outlined">Cancel</Button>
          <Button
            variant="contained"
            disabled={!selectedProject || !reason}
            onClick={() => {
              handleMoveSelected({ selectedProject, reason }); // pass data
              closeModal();
            }}
          >
            Save
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default MoveModal;
